let openMenu = () => {  
  // $("html").addClass("pgs-noscroll");
  $(".main-nav__toggler").off("click", openMenu);
  $(".js-main-nav__toggler .hamburger").addClass("is-active");
  $(".main-nav__toggler").on("click ", closeMenu);
  // util.onWindowResize(closeMenu);
  $(window).on("resize", closeMenu);
};

let closeMenu = () => {
  // $("html").removeClass("pgs-noscroll");
  $(".js-main-nav__toggler .hamburger").removeClass("is-active");
  $(".main-nav__toggler")
    .attr("tabindex", -1)
    .off("click", closeMenu)
    .on("click", openMenu);
    
  $(window).off("resize", closeMenu);
};

let initMenu = () => {
  $(".main-nav__toggler").on("click ", openMenu);
};

// export let navigationToggle = R.compose(closeMenu);
export let navigationToggle = initMenu;
